import { render } from "./PaymentHistory.vue?vue&type=template&id=05849dac&scoped=true"
import script from "./PaymentHistory.vue?vue&type=script&lang=js"
export * from "./PaymentHistory.vue?vue&type=script&lang=js"

import "./PaymentHistory.vue?vue&type=style&index=0&id=05849dac&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05849dac"]])

export default __exports__